import React, { useEffect, useState } from "react";
import { Chart, ChartCanvas } from "@react-financial-charts/core";
import { XAxis, YAxis } from "@react-financial-charts/axes";
import { format } from "d3-format";
import { rsi } from "@react-financial-charts/indicators";
import { discontinuousTimeScaleProviderBuilder } from "@react-financial-charts/scales";
import {
  RSISeries,
  AlternatingFillAreaSeries,
} from "@react-financial-charts/series";
import { SingleValueTooltip } from "@react-financial-charts/tooltip";
import { withDeviceRatio, withSize } from "@react-financial-charts/utils";
import { nFormatter } from "../../../utils/utils";

// TODO:- We can get Middle Top(overBought)  Bottom(OverSold) throught Props But For Now I've HardCoded here
const OVER_BOUGHT = 70;
const MIDDLE = 50;
const OVER_SOLD = 30;


const RSIIndicator = ({
  height,
  ratio,
  width,
  initialData,
  xAccessor,
  displayXAccessor,
  xScale,
  xExtents,
}) => {
  const [calculatedData, setCalculatedData] = useState([]);
  const xScaleProvider =
    discontinuousTimeScaleProviderBuilder().inputDateAccessor((d) => d.date);
  const rsiCalculator = rsi()
    .options({ windowSize: 14 })
    .accessor((d) => d.RSI);

  useEffect(() => {
    const formatedData = initialData.map((item) => ({
      ...item,
      date: new Date(item.timestamp),
    }));
    const calculatedData = rsiCalculator(formatedData);
    setCalculatedData(calculatedData);
  }, [initialData]);

  const { data } = xScaleProvider(calculatedData);
  const yAccessor = rsiCalculator.accessor();

  const calculateOptimalTicks = (data, chartHeight) => {
    const dataRange =
      Math.max(...data.map((item) => item.RSI)) -
      Math.min(...data.map((item) => item.RSI));
    let baseTickNumber = Math.floor(chartHeight / 100);
    const rangeAdjustment = Math.ceil(dataRange / 10);
    const finalTickNumber = baseTickNumber + rangeAdjustment;
    return Math.max(finalTickNumber, 3);
  };
  const optimalTicks = calculateOptimalTicks(calculatedData, height);

  return (
    <ChartCanvas
      height={height}
      ratio={ratio}
      width={width}
      data={data}
      displayXAccessor={displayXAccessor}
      seriesName="Data"
      xScale={xScale}
      xAccessor={xAccessor}
      xExtents={xExtents}
      disableZoom={true}
      disablePan={true}
      disableInteraction={true}
    >
      <Chart id={1} yExtents={yAccessor}>
        <XAxis strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"} />
        {/* <YAxis tickFormat={format(".2f")} ticks={5}/> */}
        <YAxis strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"} tickFormat={format(".2f")} ticks={optimalTicks} />
        <XAxis
          strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"}
          showTicks={false}
          xZoomHeight={1}
          tickPadding={0}
          axisAt={"top"}
          orient={"top"}
        />
        <YAxis
          strokeStyle={"#8d8d8d"}
          tickStrokeStyle={"#8d8d8d"}
          showTicks={false}
          yZoomWidth={1}
          tickPadding={0}
          axisAt={"left"}
          orient={"left"}
        />

        <RSISeries
          yAccessor={yAccessor}
          strokeStyle={{
            insideThreshold: "#a87878",
            outsideThreshold: "#779a74",
            top: "#555555",
            bottom: "#555555",
            middle: "#7f7f7f",
          }}
          overBought={OVER_BOUGHT}
          overSold={OVER_SOLD}
          middle={MIDDLE}
          strokeDasharray={{ middle: "Dash" }}
        />

        <AlternatingFillAreaSeries
          yAccessor={yAccessor}
          baseAt={OVER_BOUGHT}
          fillStyle={{ top: "#779a74", bottom: "transparent" }}
          strokeStyle={{ top: "#24422b", bottom: "#24422b" }}
        />

        <AlternatingFillAreaSeries
          yAccessor={yAccessor}
          baseAt={OVER_SOLD}
          fillStyle={{ top: "transparent", bottom: "#b07673" }}
          strokeStyle={{ top: "#555555", bottom: "#5a4848" }}
        />
      </Chart>
    </ChartCanvas>
  );
};

export default RSIIndicator;
